var exports = {
  "rU": "x04b3a21e--81b9c3--carousel-provider",
  "Dk": "x04b3a21e--81b9c3--carousel",
  "aw": "x04b3a21e--81b9c3--slider",
  "M6": "x04b3a21e--81b9c3--slide",
  "x6": "x04b3a21e--81b9c3--button",
};

module.exports = exports;
